import UserChangeIcon from '@ordr-as/icons/UserChangeIcon';
import FormattedMessage from '../FormattedMessage';
import { MenuAction } from '@ordr-as/umami-react/context-menu';

interface Props {
  email: string | undefined;
  onClick: () => void;
}

const ChangeUser = ({ email, onClick }: Props) => {
  return (
    <MenuAction className="border-b border-grey-lightest" onClick={onClick}>
      <div className="flex gap-3 items-center mr-3">
        <UserChangeIcon width={20} height={20} color="#1D1D1D" />
        <span className="text-base text-brand-black">
          <FormattedMessage id="header.changeUser" />
        </span>
      </div>
      <span className="text-sm text-grey-dark truncate max-w-[33vw]">{email}</span>
    </MenuAction>
  );
};

export default ChangeUser;
